
const defaultDictionaries = {
    "es": {
        "May the force be with you": "Que la fuerza te acompañe",
        "Digit1": "1",
        "Digit2": "2",
        "Digit3": "3",
        "Digit4": "4",
        "Digit5": "5",
        "Digit6": "6",
        "Digit7": "7",
        "Digit8": "8",
        "Digit9": "9",
        "Digit0": "0",
        "KeyA": "A",
        "KeyB": "B",
        "KeyC": "C",
        "KeyD": "D",
        "KeyE": "E",
        "KeyF": "F",
        "KeyG": "G",
        "KeyH": "H",
        "KeyI": "I",
        "KeyJ": "J",
        "KeyK": "K",
        "KeyL": "L",
        "KeyM": "M",
        "KeyN": "N",
        "KeyO": "O",
        "KeyP": "P",
        "KeyQ": "Q",
        "KeyR": "R",
        "KeyS": "S",
        "KeyT": "T",
        "KeyU": "U",
        "KeyV": "V",
        "KeyW": "W",
        "KeyX": "X",
        "KeyY": "Y",
        "KeyZ": "Z",
        "Comma": ",",
        "Period": ".",
        "Semicolon": ";",
        "Quote": "'",
        "BracketLeft": "[",
        "BracketRight": "]",
        "Backquote": "`",
        "Backslash": "\\",
        "Minus": "-",
        "Equal": "=",
        "AltLeft": "Alt",
        "AltRight": "Alt",
        "CapsLock": "Bloqueo May.",
        "ControlLeft": "Ctrl",
        "ControlRight": "Ctrl",
        "OSLeft": "OSLeft",
        "OSRight": "OSRight",
        "ShiftLeft": "Mayúsculas",
        "ShiftRight": "Mayúsculas",
        "ContextMenu": "ContextMenu",
        "Enter": "Intro",
        "Space": "Espacio",
        "Tab": "Tabulador",
        "Delete": "Borrar",
        "End": "Fin",
        "Help": "Ayuda",
        "Home": "Inicio",
        "Insert": "Insertar",
        "PageDown": "Re. Pag",
        "PageUp": "Av. Pag",
        "ArrowDown": "Flecha abajo",
        "ArrowLeft": "Flecha izq.",
        "ArrowRight": "Flecha der.",
        "ArrowUp": "Flecha Arriba",
        "Escape": "Escape",
        "PrintScreen": "PrintScreen",
        "ScrollLock": "ScrollLock",
        "Pause": "Pausa",
        "Put the videos side by side": "Colocar los vídeos uno junto al otro",
        "Minimize video": "Minimizar vídeo",
        "Place the video on the other side of the screen": "Colocar el vídeo al otro lado de la pantalla",
        "Maximize video": "Maximizar vídeo",
        "Swap position of the videos": "Intercambiar posición de los vídeos",
        "loadManifest(): Invalid current player state: $1": "loadManifest(): Estado actual del reproductor no válido: $1",
        "loadPlayer(): Invalid current player state: $1": "loadPlayer(): Estado actual del reproductor no válido: $1",
        "Could not load player: state transition in progress: $1": "No se puede cargar el reproductor: transición de estado en progreso: $1",
        "Could not unload player: state transition in progress: $1": "No se puede descargar el reproductor: transición de estado en progreso $1",
        "unloadManifest(): Invalid current player state: $1": "unloadManifest(): Estado actual del reprodutor no válido: $1",
        "Error loading video manifest: $1 $2": "Error cargando la información del vídeo: $1 $2"
    }
}

defaultDictionaries["es-ES"] = defaultDictionaries["es"];

export default defaultDictionaries;